import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { APIError } from "../../constants/types";
import { IRequestedUserNameRecord } from "./requestedUserName.types";

// Fetch requested user name list
export const fetchRequestedUserNameList = createAsyncThunk<
  { data: IRequestedUserNameRecord[]; totalRecords: number },
  void,
  { rejectValue: APIError }
>(
  "requestedUserName/fetchRequestedUserNameList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/user/get-user-name");
      return { data: res.data.data, totalRecords: res.data.totalRecords };
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);

// Update requested user name status
export const updateRequestedUserNameStatus = createAsyncThunk<
  void,
  IRequestedUserNameRecord,
  { rejectValue: APIError }
>(
  "requestedUserName/updateRequestedUserNameStatus",
  async (record, { rejectWithValue, dispatch }) => {
    try {
      await api.post("/user/create-user-name", record);
      dispatch(fetchRequestedUserNameList());
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);
